export enum AppView {
  Default = 'default',
  Embedded = 'embedded',
}
